import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { Toaster } from "sonner";
import Kiosk from "./pages/Kiosk";
import OwnerAccess from "./pages/OwnerAccess";
import Dashboard from "./pages/Dashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Kiosk />} />
            <Route path="/owner-access" element={<OwnerAccess />} />
            <Route path="/dashboard" element={<Dashboard />} />
          </Routes>
          <Toaster
            position="top-center"
            theme="light"
            toastOptions={{
              style: {
                background: "#ffffff",
                border: "1px solid #b8862b",
                color: "#1f1a12",
                borderRadius: "999px",
                padding: "12px 22px",
                fontSize: "14px",
                fontFamily: "'Jost', sans-serif",
                boxShadow: "0 8px 24px rgba(31, 26, 18, 0.14)",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
